{
  "alert": {
    "has_errors": "Stembureau {nr} ligt ter beoordeling bij de coördinator",
    "in_progress_other_user": "Een andere invoerder is bezig met stembureau {nr} ({name})",
    "in_progress_other_user_selector": "Een andere invoerder is bezig met stembureau {nr}",
    "finished": "Het stembureau dat je geselecteerd hebt kan niet meer ingevoerd worden",
    "finished_selector": "Stembureau {nr} <strong>({name})</strong> is al twee keer ingevoerd",
    "second_entry_not_allowed": "Je mag stembureau {nr} niet nog een keer invoeren"
  },
  "choose_polling_station": "Kies het stembureau",
  "enter_a_valid_number_to_start": "Voer een geldig nummer van een stembureau in om te beginnen",
  "insert_another": "Verder met een volgend stembureau?",
  "insert_number": "Voer het nummer in:",
  "insert_title": "Welk stembureau ga je invoeren?",
  "name_correct_warning": "Klopt de naam van het stembureau met de naam op je papieren proces-verbaal?\nDan kan je beginnen. Klopt de naam niet? Overleg met de coördinator.",
  "no_polling_station_found_with_number": "Geen stembureau gevonden met nummer {nr}",
  "searching": "aan het zoeken",
  "there_are_no_polling_stations_left_to_fill_in": "Er zijn voor jou op dit moment geen stembureaus om in te voeren",
  "unfinished_input_content": "Je bent begonnen met het invoeren van onderstaande stembureaus, maar hebt deze nog niet helemaal afgerond:",
  "unfinished_input_title": "Je hebt nog een openstaande invoer",
  "unknown_number": "Weet je het nummer niet?",
  "view_list": "Toon de lijst met nog in te vullen stembureaus"
}
